export const initLazyImages = () => {
    const lazyLoadImages = document.querySelectorAll("img[defer-src]:not([src]), img[data-src]:not([src])");
    Array.from(lazyLoadImages).forEach((el: HTMLImageElement) => {
        el.setAttribute("loading", "lazy");
        el.setAttribute("src", el.dataset.src ?? el.getAttribute("defer-src"));
        el.setAttribute("srcSet", el.dataset.srcset);
    });
};
